var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeliver(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 69,
    viewBox: "0 0 69 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 34.5,
    r: 34.5,
    fill: "#FEEFE2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.9474 42.1429C30.9474 43.7208 29.6749 45 28.1053 45C26.5356 45 25.2632 43.7208 25.2632 42.1429M30.9474 42.1429C30.9474 40.5649 29.6749 39.2857 28.1053 39.2857C26.5356 39.2857 25.2632 40.5649 25.2632 42.1429M30.9474 42.1429H39.4737M25.2632 42.1429H22.4211V36.4286M45.1579 42.1429C45.1579 43.7208 43.8854 45 42.3158 45C40.7461 45 39.4737 43.7208 39.4737 42.1429M45.1579 42.1429C45.1579 40.5649 43.8854 39.2857 42.3158 39.2857C40.7461 39.2857 39.4737 40.5649 39.4737 42.1429M45.1579 42.1429H48V33.5714M21 25H36.6316V42.1429M48 33.5714H36.6316M48 33.5714L43.7368 26.4286H36.6316M22.4211 30.7143H28.1053",
    stroke: "#FD7400",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliver);
export default __webpack_public_path__ + "static/media/deliver.14a035ef2fbcfcc10d8fe83532dd50f1.svg";
export { ForwardRef as ReactComponent };